import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { documentTemplateColumns } from "./lib/constants/documentTemplateColumns";
import { Link } from "react-router-dom";
import { fetchDocumentTemplates } from "@/lib/api/resources/documentTemplate";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";

export const DocumentTemplatesList = () => {
  const documentTemplatesQuery = useQuery({
    queryKey: ["documentTemplates"],
    queryFn: fetchDocumentTemplates,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/document-templates/create">
          <Button icon={<PlusOutlined />}>Nieuwe document template</Button>
        </Link>
      </Space>
      <Table
        columns={documentTemplateColumns}
        dataSource={documentTemplatesQuery.data?.member}
        loading={documentTemplatesQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
